var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { MdExpandMore } from 'react-icons/md';
import { Flex } from "./..";
import styled from "../../styled";
import { TableCell } from './DataTableComponents';
var SortIcon = styled(function () { return React.createElement(MdExpandMore, null); })(function (_a) {
    var theme = _a.theme, order = _a.order, isActive = _a.isActive;
    return "\n    visibility: " + (isActive ? 'visible' : 'hidden') + ";\n    margin-left: " + theme.space.xs + ";\n    transition: transform " + theme.transitions.fast + ";\n    transform: " + (order === 'asc' ? 'rotate(-180deg)' : '') + ";\n";
});
/**
 * HeaderCell is generated based on the Column passed to the DataTable component
 */
export function HeaderCell(_a) {
    var dataKey = _a.dataKey, headerRenderer = _a.headerRenderer, initialSortOrder = _a.initialSortOrder, isSortable = _a.isSortable, label = _a.label, onSort = _a.onSort, sortBy = _a.sortBy, sortOrder = _a.sortOrder, width = _a.width, headerLss = _a.headerLss, headerWrapperLss = _a.headerWrapperLss;
    var isSorted = sortBy === dataKey;
    var isActive = isSortable && isSorted;
    var onHeaderClick = function () {
        if (typeof onSort !== 'function')
            return;
        var useInitialSortOrder = !isSorted || !sortOrder;
        var currentSortOrder = useInitialSortOrder
            ? initialSortOrder
            : sortOrder === 'asc'
                ? 'desc'
                : 'asc';
        var sortOptions = {
            sortBy: dataKey,
            sortOrder: currentSortOrder
        };
        onSort(sortOptions);
    };
    return (React.createElement(TableCell, { as: "th", onClick: isSortable ? onHeaderClick : undefined, lss: __assign({ cursor: isSortable ? 'pointer' : undefined, width: width }, headerWrapperLss) },
        React.createElement(React.Fragment, null, typeof headerRenderer === 'function' ? (headerRenderer({
            label: label,
            dataKey: dataKey,
            isSortable: isSortable,
            initialSortOrder: initialSortOrder,
            onSort: onSort,
            sortOrder: sortOrder,
            sortBy: sortBy
        })) : (React.createElement(Flex, { lss: __assign({ alignItems: 'center', color: isActive ? 'secondary400' : undefined }, headerLss) },
            label || dataKey,
            isSortable ? (React.createElement(SortIcon, { order: sortOrder, isActive: isActive })) : null)))));
}
//# sourceMappingURL=HeaderCell.js.map